import { apiService } from '@/services/APIService';

export default {
  getFolders(id, params) {
    return apiService.get(`/events/${id}/gallery/folders`, params);
  },

  getPublicFolders(id, params) {
    return apiService.get(`/public/events/${id}/gallery/folders`, params);
  },

  createFolder(id, params) {
    return apiService.post(`/events/${id}/gallery/folders`, params);
  },

  updateFolder(id, params) {
    return apiService.put(`/events/${id}/gallery/folders`, params);
  },

  deleteFolder(id, params) {
    return apiService.delete(`/events/${id}/gallery/folders`, { data: params });
  },

  getImages({ event_id, folder_id }, params) {
    return apiService.get(`/events/${event_id}/gallery/folders/${folder_id}/images`, params);
  },

  getPublicImages({ event_id, folder_id }, params) {
    return apiService.get(`/public/events/${event_id}/gallery/folders/${folder_id}/images`, params);
  },

  uploadImages(id, params) {
    return apiService.post(`/events/${id}/gallery/images`, params);
  },

  deleteImage(id) {
    return apiService.delete(`/images/${id}`);
  },

  getVideos(id, params) {
    return apiService.get(`/events/${id}/gallery/videos`, params);
  },

  updateVideo(id, payload) {
    return apiService.put(`/events/${id}/gallery/videos`, payload);
  },

  uploadVideo(id, params) {
    return apiService.post(`/events/${id}/gallery/videos`, params);
  },

  deleteVideo(id, params) {
    return apiService.delete(`/events/${id}/gallery/videos`, { data: params });
  },

  getRecords(id, params) {
    return apiService.get(`/events/${id}/gallery/records`, params);
  },

  uploadRecord(id, params) {
    return apiService.post(`/events/${id}/gallery/records`, params);
  },

  updateRecord(id, payload) {
    return apiService.put(`/events/${id}/gallery/records`, payload);
  },

  deleteRecord(id, params) {
    return apiService.delete(`/events/${id}/gallery/records`, { data: params });
  },
};
